// extracted by mini-css-extract-plugin
export default {"button":"_2NXORXG1pJ4dItNXGEDJGE","text":"_1cvOgIxHJEkQyFXtk2AFu","capitalize":"_2Y8AuPL8UEprIRHqH553Aa"};